import * as React from 'react';

interface Problem {
  title: string;
  supermarket: string;
  ours: string;
}

interface ProblemSectionProps {
  problems: Problem[];
}

export function ProblemSection({ problems }: ProblemSectionProps) {
  return (
    <section className="whyus-problem">
      <style>{`
        .whyus-problem {
          padding: 56px 24px 72px;
          background: #fff;
        }
        .whyus-problem-inner {
          max-width: 720px;
          margin: 0 auto;
        }
        .whyus-problem h2 {
          font-size: 28px;
          font-weight: 800;
          color: #1a1a1a;
          margin: 0 0 8px;
          line-height: 1.3;
        }
        .whyus-problem .accent {
          font-size: 18px;
          color: #666;
          margin: 0 0 12px;
        }
        .whyus-problem .intro {
          font-size: 16px;
          color: #444;
          line-height: 1.7;
          margin: 0 0 28px;
        }
        .whyus-fail-list {
          list-style: none;
          padding: 0;
          margin: 0;
          display: grid;
          gap: 12px;
        }
        .whyus-fail-list li {
          padding: 14px 16px;
          background: #fafaf7;
          border-radius: 8px;
          border: 1px solid #eee;
        }
        .whyus-fail-list h3 {
          font-size: 16px;
          font-weight: 700;
          color: #1a1a1a;
          margin: 0 0 8px;
        }
        .whyus-fail-list p {
          font-size: 15px;
          color: #555;
          line-height: 1.5;
          margin: 0 0 6px;
        }
        .whyus-fail-list p:last-child {
          margin-bottom: 0;
        }
        .whyus-fail-list .ours {
          color: #176b1c;
          font-weight: 600;
        }
        @media (max-width: 640px) {
          .whyus-problem h2 {
            font-size: 24px;
          }
        }
      `}</style>
      <div className="whyus-problem-inner">
        <h2>El changuito online con la rueda rota</h2>
        <p className="accent">Ya probaste comprar en la web del súper. Sabés cómo termina.</p>
        <p className="intro">
          Verdulería con lista por WhatsApp. El súper que te cambia lo que pediste. La web que dice disponible y después no hay. Mismo changuito, distinta pantalla.
        </p>
        <ul className="whyus-fail-list">
          {problems.map((problem) => (
            <li key={problem.title}>
              <h3>{problem.title}</h3>
              <p>{problem.supermarket}</p>
              <p className="ours">{problem.ours}</p>
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
}
